<template>
  <div>
    <!-- Top Action Row -->
    <div class="d-flex align-center mb-6 px-1">
      <div class="caption font-weight-black text-uppercase tracking-widest grey--text">Maestro de Orígenes</div>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        class="font-weight-black text-uppercase tracking-widest rounded-lg px-8 h-44 shadow-lg shadow-success"
        @click="update(-1)"
      >
        <v-icon left size="16">fas fa-plus-circle</v-icon>
        Nuevo Origen
      </v-btn>
    </div>

    <!-- Search Section -->
    <v-card outlined class="bg-lightgrey border-dashed pa-4 mb-6 d-flex align-center rounded-xl elevation-0">
      <v-text-field
        v-model="search"
        placeholder="Buscar origen por nombre..."
        prepend-inner-icon="fas fa-search"
        outlined
        dense
        hide-details
        class="modern-search-input bg-white elevation-0"
        :loading="loading"
        color="primary"
      ></v-text-field>
    </v-card>

    <!-- Table Section -->
    <v-card outlined class="modern-table-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :loading="loading"
        :search="search"
        dense
        class="modern-data-table"
        sort-by="name"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-angle-double-left',
          lastIcon: 'fas fa-angle-double-right',
          prevIcon: 'fas fa-angle-left',
          nextIcon: 'fas fa-angle-right'
        }"
      >
        <template v-slot:item.id="{ item }">
          <span class="caption font-weight-black grey--text opacity-60 tracking-wider">REF #{{ item.id }}</span>
        </template>
        
        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center py-2">
            <v-avatar size="32" color="blue lighten-5" class="mr-3">
              <v-icon x-small color="blue darken-2">fas fa-map-marker-alt</v-icon>
            </v-avatar>
            <span class="body-2 font-weight-black primary--text">{{ item.name }}</span>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon color="primary" class="grey lighten-4" small @click.stop="update(item.id)">
            <v-icon size="14">fas fa-pen</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Refined Dialog -->
    <v-dialog v-model="showDialog" max-width="460" content-class="modern-dialog-shadow" persistent>
      <v-card class="overflow-hidden rounded-xl bg-white elevation-24">
        <origin-create-update 
          :id="selectedId" 
          @updated="fetch" 
          @close="showDialog=false"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fethOrigins } from '@/api/salesNotes'
import notifications from '@/utils/notifications'
import OriginCreateUpdate from '@/components/sales/OriginCreateUpdate.vue'

export default {
  name: 'Origins',
  components: { OriginCreateUpdate },
  data() {
    return {
      loading: false,
      selectedId: -1,
      items: [],
      search: '',
      showDialog: false,
      headers: [
        { text: 'Referencia', align: 'start', value: 'id', class: 'caption font-weight-black tracking-widest grey--text', width: '120px' },
        { text: 'Nombre del Origen', align: 'start', value: 'name', class: 'caption font-weight-black tracking-widest grey--text' },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false, class: 'caption font-weight-black tracking-widest grey--text', width: '100px' }
      ],
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const res = await fethOrigins()
        this.items = res
      } catch (err) {
        notifications.showError('Error', 'Cargando Orígenes ' + err)
      } finally {
        this.loading = false
      }
    },
    update(id) {
      this.selectedId = id
      this.showDialog = true
    }
  },
  async mounted() {
    this.fetch()
  }
}
</script>

<style scoped>
.modern-config-view { font-family: 'Outfit', sans-serif !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.5px; }
.bg-lightgrey { background-color: #f8fbfc !important; }
.border-dashed { border: 1px dashed #e2e8f0 !important; }
.h-44 { height: 44px !important; }
.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important; }
.shadow-success { box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.3) !important; }
.opacity-60 { opacity: 0.6; }

.modern-search-input { border-radius: 24px !important; width: 100%; max-width: 400px; }
.modern-search-input >>> fieldset { border-radius: 24px !important; border: 1px solid #e2e8f0 !important; }

.modern-table-card { border-radius: 12px !important; border: 1px solid #e2e8f0 !important; }
.modern-data-table >>> .v-data-table-header { background-color: #f8fbfc !important; }
.modern-data-table >>> th { height: 52px !important; text-transform: uppercase; font-size: 0.7rem !important; vertical-align: middle !important; }
.modern-data-table >>> td { height: 64px !important; border-bottom: 1px solid rgba(0,0,0,0.03) !important; }

.modern-dialog-shadow { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important; }
</style>